import { ROUTES } from '@/static/global-variables';
const Signee = () => import('../views/signee.vue');
const Signature = () => import('../views/signature.vue');
const AoC = () => import('../views/acknowledgement-of-content.vue');
const Samples = () => import('../views/samples.vue');
const Inquiries = () => import('../views/inquiries.vue');
const Canceled = () => import('../views/canceled.vue');
const Completed = () => import('../views/completed.vue');
const Expired = () => import('../views/expired.vue');
const Unsupported = () => import('../views/unsupported.vue');
const Loading = () => import ('../views/loading.vue');
const LinkError = () => import('../views/link-error.vue');


export default [
    {
        path: '/signee/:signinId/:uuid?',
        name: ROUTES.SIGNEE,
        component: Signee
    },
    {
        path: '/inquiries/:signinId/:uuid?',
        name: ROUTES.INQUIRIES,
        component: Inquiries
    },
    {
        path: '/signee-share-link/:signinId/:uuid?',
        name: ROUTES.SHARE_LINK_SIGNEE,
        component: Signee,
        beforeEnter: (to, from, next) => {
            if(from.name === ROUTES.SHARE_LINK || from.name === ROUTES.SAMPLES) {
                next();
            } else {
                next({ name: ROUTES.EXPIRED });
            }
        }
    },
    {
        path: '/inquiries-share-link/:signinId/:uuid?',
        name: ROUTES.SHARE_LINK_INQUIRIES,
        component: Inquiries,
        beforeEnter: (to, from, next) => {
            if(from.name === ROUTES.SHARE_LINK || from.name === ROUTES.SIGNATURE) {
                next();
            } else {
                next({ name: ROUTES.EXPIRED });
            }
        }
    },
    {
        path: '/share-link/:channelId/:refreshed?',
        name: ROUTES.SHARE_LINK,
        component: Loading
    },
    {
        path: '/sample-opt-in/:signinId',
        name: ROUTES.SAMPLE_OPT_IN,
        component: Signature,
        beforeEnter: (to, from, next) => {
            if(from.name === ROUTES.SHARE_LINK) {
                next();
            } else {
                next({ name: ROUTES.EXPIRED });
            }
        }
    },
    {
        path: '/samples',
        name: ROUTES.SAMPLES,
        component: Samples,
        beforeEnter: (to, from, next) => {
            if(from.name === ROUTES.SIGNATURE || from.name === ROUTES.SHARE_LINK_SIGNEE || from.name === ROUTES.SIGNEE) {
                next();
            } else {
                next({ name: ROUTES.EXPIRED });
            }
        }
    },
    {
        path: '/signature',
        name: ROUTES.SIGNATURE,
        component: Signature,
        beforeEnter: (to, from, next) => {
            if(from.name === ROUTES.INQUIRIES || from.name === ROUTES.SHARE_LINK_INQUIRIES || from.name === ROUTES.SAMPLES) {
                next();
            } else {
                next({ name: ROUTES.EXPIRED });
            }
        }
    },
    {
        path: '/aoc/:signinId/:uuid?',
        name: ROUTES.AOC,
        component: AoC
    },
    {
        path: '/canceled',
        name: ROUTES.CANCELED,
        component: Canceled
    },
    {
        path: '/completed',
        name: ROUTES.COMPLETED,
        component: Completed
    },
    {
        path: '/unsupported',
        name: ROUTES.UNSUPPORTED,
        component: Unsupported
    },
    {
        path: '/expired',
        name: ROUTES.EXPIRED,
        component: Expired
    },
    {
        path: '/link-error',
        name: ROUTES.LINK_ERROR,
        component: LinkError
    },
    {
        path: "*",
        redirect: "/link-error"
    }
];
